/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'diff': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M3 1c-1.11 0-2 .89-2 2v2h2V3h2V1H3m4 0v2h3V1H7m5 0v2h2v2h2V3c0-1.11-.89-2-2-2h-2M1 7v3h2V7H1m13 0v7H7v6c0 1.11.89 2 2 2h11c1.11 0 2-.89 2-2V9c0-1.11-.89-2-2-2h-6m2 2h4v11H9v-4h5c1.11 0 2-.89 2-2V9M1 12v2c0 1.11.89 2 2 2h2v-2H3v-2H1z"/>'
  }
})
